import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { fetchAdapters, fetchSystemFilestore, updateSystemFilestore } from '../../apis';
import { generateForm } from '../index';
import { get, Map } from 'immutable';
import { adapterPropertiesFields, propertiesFromAdapters, propertiesFromValues } from './helpers';
import { handleFormErrors } from '../form/Form.helpers';

var dataSources = function dataSources() {
  return {
    filestoreAdapters: {
      fn: fetchAdapters,
      params: [{
        slug: 'SYSTEM',
        type: 'filestore'
      }],
      transform: function transform(result) {
        return result.adapters;
      }
    },
    filestore: {
      fn: fetchSystemFilestore,
      params: [],
      transform: function transform(result) {
        return result.filestore;
      }
    },
    adapterProperties: {
      fn: propertiesFromAdapters,
      params: function params(_ref) {
        var filestoreAdapters = _ref.filestoreAdapters;
        return filestoreAdapters && [filestoreAdapters, 'class'];
      }
    }
  };
};

var handleSubmit = function handleSubmit() {
  return function (values) {
    return updateSystemFilestore({
      filestore: values.toJS()
    }).then(handleFormErrors('filestore', 'There was an error saving the Filestore.'));
  };
};

var fields = function fields() {
  return function (_ref2) {
    var filestoreAdapters = _ref2.filestoreAdapters,
        filestore = _ref2.filestore,
        adapterProperties = _ref2.adapterProperties;

    if (filestore && filestoreAdapters && adapterProperties) {
      var properties = adapterPropertiesFields({
        adapterProperties: adapterProperties,
        defaultAdapter: filestore,
        adapterType: 'adapterClass'
      });
      return filestoreAdapters && filestore && [{
        name: 'slug',
        label: 'Slug',
        type: 'text',
        enabled: false,
        initialValue: get(filestore, 'slug', '')
      }, {
        name: 'adapterClass',
        label: 'Filestore Adapter',
        type: 'select',
        required: true,
        options: filestoreAdapters.map(function (adapter) {
          return Map({
            label: adapter.get('name'),
            value: adapter.get('class')
          });
        }),
        initialValue: get(filestore, 'adapterClass', '')
      }, {
        name: 'properties',
        label: 'Filestore Properties',
        type: null,
        required: false,
        visible: false,
        serialize: function serialize(_ref3) {
          var values = _ref3.values;
          return propertiesFromValues(values, 'adapterClass');
        }
      }].concat(_toConsumableArray(properties));
    }
  };
};

export var SystemFilestoreForm = generateForm({
  formOptions: ['slug'],
  dataSources: dataSources,
  fields: fields,
  handleSubmit: handleSubmit
});